module.exports = __webpack_public_path__ + "img/34.d9a32750.jpg";